<div class="mat-body text-center">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
    <form #formValidation="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
        <div class="head-form mb-4">
            <i class="icon-exclamation red-icon-exclamation mb-3"></i>
            {{ data.text|translate }}
        </div>

        <mat-form-field class="full-width mb-3 mb-sm-4" appearance="outline">
            <textarea
                name="reason"
                matInput
                required
                [(ngModel)]="data.validation.reason"
                #reasonCtrl="ngModel"
                maxlength="501"
                class="scroll-textarea"
            ></textarea>
        </mat-form-field>

        <p class="aviso" *ngIf="data.validation.reason.length > 500">{{ 'dialog.message-500-character'|translate }}</p>

        <div class="row justify-content-center btn-001">
            <div class="col-12 col-sm-6">
                <button
                    type="submit"
                    class="full-width mat-elevation-z0"
                    mat-raised-button
                    color="blue"
                    [disabled]="!formValidation.valid || data.validation.reason.length > 500"
                >
                    {{ 'general.accept'|translate }}
                </button>
            </div>
        </div>
    </form>
</div>
